module.exports = __webpack_public_path__ + "img/natureBasket.41ef1219.jpeg";